export default __webpack_public_path__ + "static/media/Analysis-amico.be2fd53b.svg";